import type {Expand} from '../../../../api/types';

export const regularInviteExpand: Expand = {
  invite: [
    [
      'user_id',
      {name: 'User not found'},
      {
        user: ['avatar_id'],
      },
    ],
  ],
};

export const proposedMembershipExpand: Expand = {
  membership: [
    [
      'user_id',
      {name: 'User not found'},
      {
        user: ['avatar_id'],
      },
    ],
    'course_id',
  ],
};
